import angular from "angular";
import {
  machineEditFormComponentOptions,
  vsComponentName as machineEditFormComponentOptionsName,
} from "./machineEditForm";

import { vsModuleName as progressivesModuleName } from "./progressives/module";
import {
  MachineConfigurationViewComponentOptions,
  vsComponentName as MachineConfigurationViewComponentOptionsName,
} from "./machineConfigurationView";

export const vsModuleName = "SlotTrak.Machines.Components";

angular
  .module(vsModuleName, ["records", progressivesModuleName])
  .component(
    MachineConfigurationViewComponentOptionsName,
    MachineConfigurationViewComponentOptions
  )
  .component(
    machineEditFormComponentOptionsName,
    machineEditFormComponentOptions
  );
